// extracted by mini-css-extract-plugin
export default {"root":"Input_root__O-YU0"};